// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SnoozeIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M19.5 12.51a.7.7 0 0 0-.78.2 5.4 5.4 0 0 1-9.43-3.3 5.2 5.2 0 0 1 1.52-3.8c.2-.22.26-.53.14-.8a.7.7 0 0 0-.7-.39 9 9 0 0 0-6.04 3 8.7 8.7 0 0 0 .69 12.25 9.1 9.1 0 0 0 12.53-.34 8.7 8.7 0 0 0 2.54-6.14v-.02a.7.7 0 0 0-.47-.66m-8.52 8.1a7.6 7.6 0 0 1-6.12-3.07A7.3 7.3 0 0 1 3.8 10.9a7.5 7.5 0 0 1 4.86-4.75 6.5 6.5 0 0 0-.29 5.65 6.8 6.8 0 0 0 4.26 3.83c1.93.6 4.03.32 5.72-.76A7.4 7.4 0 0 1 15.7 19a7.7 7.7 0 0 1-4.7 1.61m1.6-17.91q0-.29.22-.5.2-.2.5-.2h2.94c.26 0 .5.14.63.37.12.23.1.5-.04.72l-2.2 3.18h1.6c.4 0 .72.3.72.7a.7.7 0 0 1-.71.7H13.3a.7.7 0 0 1-.63-.38.7.7 0 0 1 .04-.72L14.9 3.4h-1.6a.7.7 0 0 1-.5-.2.7.7 0 0 1-.21-.5M22 9.66a.7.7 0 0 1-.2.49.7.7 0 0 1-.51.2h-2.1a.7.7 0 0 1-.63-.37.7.7 0 0 1 .04-.71l1.35-1.96h-1a.7.7 0 0 1-.7-.7c0-.38.31-.7.7-.7h2.34c.26 0 .5.15.63.38.12.22.1.5-.04.71l-1.35 1.96h.76q.3 0 .5.2t.21.5"
    />
  </svg>,
  "Snooze",
);
export default SnoozeIcon;
